module.exports = __webpack_public_path__ + "41c2105cdbdca8a314b6597b55702b42.webp";